import React from "react";
import { Card, Select, Button, Dropdown, List, Tooltip, Spin } from "antd";
import { DownOutlined } from "@ant-design/icons";
import useTrainingGroup from "PlatForms/OrgLMS/Hooks/AdminHooks/useTraining";
import { useNavigate } from "react-router-dom";
const { Option } = Select;
const Trainings = () => {
  const {
    loading,
    viewAll,
    setViewAll,
    menuItems,
    handleDragStart,
    handleDrop,
    groupMembers,
    isButtonDisabled,
    removeMember,
    availableLearner,
    selectedMentor,
    teams,
    teamsLoading,
    submitting,
    finalizeGroup,
    selectedGroup,
    setSelectedGroup,
  } = useTrainingGroup();
  const navigate = useNavigate();
  return (
    <Card className="card-professional" title="Group Formation">
      <Button className="mb-3" type="primary" onClick={() => navigate("/training-list")}>
        View Created Groups
      </Button>
      <div className="row">
        <div className="col-md-5">
          <h5>Available Employees</h5>
          <div
            style={{
              maxHeight: "270px",
              overflowY: availableLearner.length > 6 ? "auto" : "visible",
              border: "1px solid #ddd",
              padding: "5px",
            }}
          >
            <List
              loading={loading}
              bordered
              dataSource={viewAll ? availableLearner : availableLearner.slice(0, 5)}
              renderItem={(learner) => (
                <List.Item
                  className="draggable"
                  draggable
                  onDragStart={(e) => handleDragStart(e, learner)}
                >
                  {learner.learnerId} - {learner.learnerFirstName} {learner.learnerLastName} -{" "}
                  {learner.title}
                </List.Item>
              )}
            />
          </div>
          {availableLearner.length > 5 && (
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Button type="link" onClick={() => setViewAll(!viewAll)}>
                {viewAll ? "Hide" : "View More"}
              </Button>
            </div>
          )}
        </div>
        <div className="col-md-7">
          <h5>Assign Mentor</h5>
          <Dropdown className="mb-2" menu={{ items: menuItems, style: { maxWidth: 500 } }} trigger={["click"]}>
            <Button className="w-100" type="dashed">
              {selectedMentor.name ? selectedMentor.name : "Choose a Mentor"} <DownOutlined />
            </Button>
          </Dropdown>
          <div className="group-card" onDragOver={(e) => e.preventDefault()} onDrop={handleDrop}>
            {groupMembers.length === 0 ? (
              "Drag learners here"
            ) : (
              <>
                {groupMembers.map((learner, index) => (
                  <div key={index} className="group-member">
                    {learner.learnerFirstName} {learner.learnerLastName} - {learner.title}
                    <span className="remove-btn" onClick={() => removeMember(learner)}>
                      &times;
                    </span>
                  </div>
                ))}
                {groupMembers.length > 0 && (
                  <div className="text-muted mt-2">
                    {groupMembers.length}/50 learners (Course: {groupMembers[0].title})
                  </div>
                )}
              </>
            )}
          </div>
          <br />
          <h5 className="mt-3">Choose Team</h5>
          <Spin spinning={teamsLoading}>
            <Select
              className="mb-2"
              placeholder={selectedMentor.id ? "Select a team" : "First select a mentor"}
              style={{ width: "100%" }}
              onChange={setSelectedGroup} // Changed from handleGroupSelect
              value={selectedGroup}
              showSearch
              optionFilterProp="children"
              disabled={!selectedMentor.id || teamsLoading}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {teams.map((team) => (
                <Option key={team.id} value={team.id}>
                  {team.name}
                </Option>
              ))}
            </Select>
          </Spin>
        </div>
      </div>
      <Tooltip
        title={isButtonDisabled ? "Select at least 1 learners, a team, and a mentor" : ""}
      >
        <Button
          loading={submitting}
          disabled={submitting || isButtonDisabled}
          type="primary"
          className="mt-3"
          onClick={finalizeGroup}
          style={{ float: "right" }}
        >
          {submitting ? "Submitting" : "Finalize Group"}
        </Button>
      </Tooltip>
    </Card>
  );
};
export default Trainings;
